import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { ResourcePreview } from '../../types';

interface ResourceCardProps {
  data: ResourcePreview;
}

export function ResourceCard({ data }: ResourceCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => navigate(data.detailUrl)}
    >
      <CardHeader className="p-4 pb-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-sm truncate">{data.title}</CardTitle>
          <Badge variant="secondary" className="shrink-0">{data.type}</Badge>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0 text-sm text-muted-foreground">
        <p>{data.subject}</p>
      </CardContent>
    </Card>
  );
}
